/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ShowMoreText from 'react-show-more-text';

export interface IHeroDescriptionProps {
  heroTitle?: string;
  description?: string;
}
export const HeroDescription = (props: IHeroDescriptionProps) => {
  const { heroTitle, description } = props;

  const _renderDescription = () => {
    if (
      description &&
      !Array.isArray(description) &&
      typeof (description === 'string')
    ) {
      return (
        // <ShowMoreText
        //   lines={2}
        //   more="Show more"
        //   less="Show less"
        //   className="content-css"
        //   anchorClass="show-more-less-clickable"
        //   expanded={false}
        //   truncatedEndingComponent={"... "}
        // >
        <p className="fs-6 text-dark mb-0 w-100 align-justify">{description}</p>
        // </ShowMoreText>
      );
    }
    if (Array.isArray(description)) {
      return (
        // <ShowMoreText
        //   lines={2}
        //   more="Show more"
        //   less="Show less"
        //   className="content-css"
        //   anchorClass="show-more-less-clickable"
        //   expanded={false}
        //   truncatedEndingComponent={"... "}
        // >
        <>
          {description?.map((str: string, index: number) => {
            return (
              <>
                <p
                  className="fs-6 text-dark mb-0 w-100 align-justify"
                  key={`list-${index}`}
                >
                  {str}
                </p>
                <br />
              </>
            );
          })}
        </>
        // </ShowMoreText>
      );
    }
    return null;
  };

  const _renderTitleIf = () => {
    if (heroTitle) {
      return <h3>{heroTitle}</h3>;
    }
  };

  return (
    <Row className="pb-3 pt-2">
      <Col xs="auto" className="px-3">
        {_renderTitleIf()}
        {_renderDescription()}
      </Col>
    </Row>
  );
};

HeroDescription.defaultProps = {
  heroTitle: '',
  description: [],
};
